<script setup lang="ts">
import { useCasinoBets } from "@/app/composables/useCasinoBets"
import { t } from "@/app/composables/useI18n"
import { onMounted } from "vue"
import Session from "../Session.vue"

const {
  state,
  hasMoreTickets,
  showEmptyState,
  fetchBets,
  handleFetchMore,
} = useCasinoBets()

onMounted(() => fetchBets())
</script>

<template>
  <div v-if="state.tickets.length > 0">
    <Session
      v-for="ticket in state.tickets"
      :key="ticket.id"
      :ticket="ticket"
      :result="34"
    />
  </div>

  <div v-else-if="showEmptyState" class="empty-data">
    {{ t("general.dont_have") }} {{ t("general.casino") }} {{ t("general.bets") }}
  </div>

  <button
    v-if="hasMoreTickets"
    class="load-more"
    :disabled="state.loading"
    @click="handleFetchMore"
  >
    {{ state.loading ? t('general.loading') : t('general.load_more') }}
  </button>
</template>

<style lang="scss" scoped>
.load-more {
  background: var(--be-primary-btn);
  height: 45px;
  width: calc(100% - 32px);
  border-radius: 8px;
  margin: 10px 16px;
  color: var(--be-primary-btn-label);

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.empty-data {
  text-align: center;
  margin: 40px 0;
}
</style>
